import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';

import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import {
  ColorSchemeService,
  DestroyAbleComponent,
  Theme,
} from '@univacity/angular/ui';
import { FormsModule } from '@angular/forms';
import { Setting } from '@univacity/shared/types';

@Component({
  selector: 'un-theme-switcher',
  imports: [NzSegmentedModule, FormsModule],
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeSwitcherComponent
  extends DestroyAbleComponent
  implements OnInit
{
  options: Theme[] = ['light', 'auto', 'dark'];

  activeTheme = 1;

  constructor(
    private theme: ColorSchemeService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    const active = localStorage.getItem(Setting.prefersColor) as Theme | null;
    switch (active) {
      case 'light': {
        this.activeTheme = 0;
        break;
      }
      case 'dark': {
        this.activeTheme = 2;
        break;
      }
      default:
        this.activeTheme = 1;
    }
  }

  changeTheme(index: number | string) {
    this.theme.update(this.options[+index]);
    this.cdr.detectChanges();
  }
}
